import React from "react";
import Icon from "../lib/icon";
import "./scss/badge-status.scss";

const STATUS_CONFIG = {
  not_paid: {
    label: "Не оплачен",
    className: "badge--danger",
    icon: "circle-warning"
  },
  new_order: {
    label: "Новый заказ",
    className: "badge--primary",
    icon: "clock"
  },
  in_processing: {
    label: "В обработке",
    className: "badge--neutral",
    icon: "clock"
  },
  accepted: {
    label: "Принят магазином",
    className: "badge--neutral",
    icon: "check"
  },
  assembling: {
    label: "В сборке",
    className: "badge--warning",
    icon: "bag"
  },
  delayed: {
    label: "Задерживается",
    className: "badge--warning",
    icon: "clock"
  },
  with_courier: {
    label: "У курьера",
    className: "badge--success-light",
    icon: "moped"
  },
  delivered: {
    label: "Доставлено",
    className: "badge--success",
    icon: "check"
  },
  cancelled: {
    label: "Отменён",
    className: "badge--cancel",
    icon: "frown"
  }
};

export default function BadgeStatus({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: "Неизвестно",
    className: "badge--neutral",
    icon: "clock"
  };

  return (
    <div className={`badge-status ${config.className}`}>
      <Icon name={config.icon} color="#FFFFFF" width={14} height={14} />
      <span>{config.label}</span>
    </div>
  );
}
